{
  "intro": "Private networks connect your servers with each other without going over the internet. Traffic inside a network is free and does not count towards the servers' traffic. A network lives in one network zone; servers of that zone can join it.",
  "create": "Create network",
  "createLead": "A network needs a private address range and at least one subnet in the zone where your servers are.",
  "empty": "No private networks yet",
  "emptyLead": "Put servers that talk to each other (an app and its database, say) into one network: they reach each other on private addresses, the database needs no public port, and the traffic costs nothing.",
  "name": "Name",
  "nameHint": "What the network is for, e.g. backend.",
  "ipRange": "IP range",
  "ipRangeHint": "A private range, from /8 to /24. 10.0.0.0/16 leaves room for 256 subnets.",
  "ipRangeWhy": "Only private ranges (10.0.0.0/8, 172.16.0.0/12, 192.168.0.0/16) can be used. Pick one that does not clash with networks you connect to, such as your office VPN.",
  "zone": "Network zone",
  "zoneHint": "Servers of this zone can join the first subnet.",
  "zoneWhy": "A network zone is a group of nearby locations, e.g. eu-central covers Falkenstein, Nuremberg and Helsinki. A subnet works in one zone only.",
  "subnet": "First subnet",
  "subnetHint": "Part of the range where servers get their addresses. A /24 holds 253 servers.",
  "submit": "Create network",
  "created": "Network “{{name}}” created",
  "rangeInvalid": "Write a range like 10.0.0.0/16, starting at the first address of the block.",
  "rangeNotPrivate": "Use a private range (10.x, 172.16–31.x or 192.168.x) from /8 to /24.",
  "subnetInvalid": "Write a subnet like 10.0.0.0/24.",
  "subnetOutside": "The subnet must lie inside the network's range.",
  "subnets": "Subnets",
  "servers": "Servers",
  "createdOn": "Created",
  "open": "Open",
  "delete": "Delete",
  "protected": "Delete protection",
  "protectedReason": "Delete protection is on; turn it off in the settings first.",
  "notFound": "This network no longer exists.",
  "back": "All networks",
  "tabs": {
    "resources": "Resources",
    "subnets": "Subnets",
    "routes": "Routes",
    "settings": "Settings",
    "delete": "Delete"
  },
  "resourcesIntro": "Servers in this network and their private addresses. A server can join when the network has a subnet in the server's zone.",
  "attach": "Attach server",
  "attachLead": "The server gets an address in the subnet of its zone and a new network interface. Most images bring it up by themselves; on others, set it up in the system.",
  "attachServer": "Server",
  "attachNone": "No server can be attached: every server of the project is already in the network, or none is in a zone of its subnets.",
  "attachIp": "Fixed address (optional)",
  "attachIpHint": "Leave empty and the provider picks the next free address.",
  "attachSubmit": "Attach",
  "attached": "Attaching “{{name}}” to the network",
  "noServers": "No servers in this network yet",
  "noServersLead": "Attach a server to give it a private address in this network.",
  "privateIp": "Private address",
  "detach": "Detach",
  "detachTitle": "Detach “{{name}}” from the network?",
  "detachConsequence": "The server loses its private address {{ip}}: other servers can no longer reach it through this network.",
  "detachPublic": "Its public addresses are not affected.",
  "detached": "Detaching “{{name}}”",
  "subnetsIntro": "Subnets divide the range. Servers get their addresses from the subnet of their zone; the first address of each subnet is its router.",
  "addSubnet": "Add subnet",
  "addSubnetLead": "The subnet must lie inside {{range}} and must not overlap the other subnets.",
  "subnetRange": "Subnet range",
  "subnetRangeHint": "For example 10.0.1.0/24.",
  "subnetOverlaps": "This range overlaps a subnet the network already has.",
  "subnetZone": "Network zone",
  "subnetType": "Type",
  "subnetTypes": {
    "cloud": "Cloud servers",
    "server": "Dedicated servers",
    "vswitch": "vSwitch"
  },
  "gateway": "Router",
  "subnetAdded": "Adding subnet {{range}}",
  "deleteSubnet": "Delete subnet",
  "deleteSubnetTitle": "Delete subnet {{range}}?",
  "deleteSubnetConsequence": "Servers of zone {{zone}} can no longer join through this subnet.",
  "deleteSubnetInUse": "Servers that still have addresses in it must be detached first.",
  "subnetDeleted": "Deleting subnet {{range}}",
  "subnetBusy": "Servers have addresses in this subnet; detach them first.",
  "routesIntro": "Routes send traffic for other address ranges through one of your servers, for example a server acting as a VPN or NAT gateway. The gateway is that server's private address.",
  "addRoute": "Add route",
  "addRouteLead": "Traffic for the destination is sent to the gateway, which must be an address inside {{range}}.",
  "destination": "Destination",
  "destinationHint": "The range to route, e.g. 10.100.0.0/16, or 0.0.0.0/0 for all traffic leaving the network.",
  "routeGateway": "Gateway",
  "routeGatewayHint": "Private address of the server that forwards the traffic.",
  "gatewayInvalid": "Write an address inside the network, e.g. 10.0.0.2.",
  "routeAdded": "Adding route to {{destination}}",
  "noRoutes": "No routes",
  "noRoutesLead": "Without routes, servers reach only the addresses of this network privately. Add a route when one server forwards traffic for others.",
  "deleteRoute": "Delete route",
  "deleteRouteTitle": "Delete the route to {{destination}}?",
  "deleteRouteConsequence": "Traffic for {{destination}} is no longer sent to {{gateway}}.",
  "routeDeleted": "Deleting route to {{destination}}",
  "settingsIntro": "Name, labels and protection of the network.",
  "rename": "Name",
  "saved": "Saved",
  "labels": "Labels",
  "labelsHint": "One per line as key=value, e.g. env=production. Labels help to find and group resources.",
  "labelsInvalid": "Line {{line}} is not a valid label: key=value, letters, digits, dot, dash or underscore, at most 63 characters each.",
  "protection": "Delete protection",
  "protectionOn": "Delete protection is on: the network cannot be deleted, by you or by mistake, until you turn it off.",
  "protectionOff": "Delete protection is off: anyone with write access can delete the network.",
  "protectionEnable": "Turn on delete protection",
  "protectionDisable": "Turn off delete protection",
  "protectionChanging": "Changing protection",
  "deleteIntro": "Deleting a network cannot be undone.",
  "deleteTitle": "Delete the network “{{name}}”?",
  "deleteServers": "Attached servers ({{count}}) lose their private address in this network and can no longer reach each other through it.",
  "deleteSubnetsRoutes": "Its subnets and routes are removed with it.",
  "deletePublic": "Servers keep their public addresses and their data.",
  "deleteBlocked": "Delete protection is on. Turn it off in the settings first.",
  "toSettings": "Go to settings",
  "deleted": "Network “{{name}}” deleted",
  "running": "Change in progress…"
}
